import { useEffect, useMemo, useState } from 'react'
import TypyPlacowekService from '@/services/TypyPlacowekService'

export default function useTypFilterModal(isOpen, selectedTypId) {
	const [searchTerm, setSearchTerm] = useState('')
	const [items, setItems] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)
	const [activeId, setActiveId] = useState(selectedTypId || '')

	useEffect(() => {
		if (!isOpen) return
		setActiveId(selectedTypId || '')
	}, [isOpen, selectedTypId])

	useEffect(() => {
		if (!isOpen) return
		let cancelled = false
		const loadItems = async () => {
			setLoading(true)
			setError(null)
			const query = (searchTerm || '').trim()
			const options = { limit: 200, sortColumn: 'typ', sortDirection: 'asc' }
			const result = query
				? await TypyPlacowekService.search(query, options)
				: await TypyPlacowekService.getAll(options)
			if (cancelled) return
			if (result?.error) {
				setError(result.error)
				setItems([])
			} else {
				setItems(Array.isArray(result?.data) ? result.data : [])
			}
			setLoading(false)
		}
		const timer = setTimeout(loadItems, 200)
		return () => {
			cancelled = true
			clearTimeout(timer)
		}
	}, [isOpen, searchTerm])

	const selectedName = useMemo(() => {
		const selected = items.find(item => (item?._id || item?.id) === activeId)
		return selected?.typ || ''
	}, [items, activeId])

	return { searchTerm, setSearchTerm, items, loading, error, activeId, setActiveId, selectedName, clearFilter: () => setActiveId('') }
}
